import { useState } from "react";
import { apiRequest } from "../utils/apiRequest";
import { globalEndpoints } from "../globals/globalEndpoints";
import { IAnalyticsEventData } from "../types/IAnalyticsEventData";

export interface IAnalyticsEventsProps {
  trackEvent: (data: IAnalyticsEventData) => void;
  error: string | null;
}

const useAnalyticsEvents = (): IAnalyticsEventsProps => {
    const [error, setError] = useState<string | null>(null);

    const trackEvent = (data: IAnalyticsEventData) => {
        setError(null)

        apiRequest(globalEndpoints.analytics.clientEvent, 'POST', data)
        .then(async (res) => {
            if (res.ok) return
            const parsed = await res.json()
            throw new Error(parsed?.message || 'An error occurred while tracking the event')
        })
        .catch((error) => {
            setError(error?.message || 'An error occurred while tracking the event')
        })
    }

    return {
        trackEvent,
        error
    }
}

export default useAnalyticsEvents;